
import { React, useState } from "react";
import { Typography, Grid } from "@mui/material";
import "./styles.css";

export default function PaymentDetails(props) {

  const [labourFee, setLabourFee] = useState(false);
  return (
      <Grid
       className="labour-fee"
       display="flex" flexDirection='column'
        sx={{ boxShadow: "0px 3px 6px #7E7E7E29" }}
      >
        <Typography className="summaryLabelCls">Payment Details</Typography>
        <Grid>
        <Grid container spacing={1} pt={1} pb={1} >
          <Grid item xs={9}>
            <span className="summaryLabelCls"> Partial payment done</span>
            <div
              className="insideCntCls"
              style={{ textDecoration:'none', marginTop:'5px'}}
              onClick={() => setLabourFee(!labourFee)}
            >
              On 18/10/2022
            </div>
          </Grid>
          <Grid item xs={3}>
            <span className="summaryValueCls">
             :  R 20.00
            </span>
          </Grid>
            </Grid>
            <hr
        style={{
          background: '#DBDBDB',
          color: '#DBDBDB',
          borderColor: '#DBDBDB',
          height: '0.2px',
          margin:'25px 0px'
        }}/>
        
        <Grid container spacing={1} pt={1} pb={2} >
          <Grid item xs={9}>
            <span className="summaryLabelCls"> Balance amount To pay</span>
          </Grid>
          <Grid item xs={3}>
            <span className="summaryValueCls">
             :  R 84.00
            </span>
          </Grid>
            </Grid>
        </Grid>

        <Typography
          borderTop="1px dashed #3C8C9E;"
          borderBottom=".5px solid #3C8C9E;"
          fontSize="20px"
          id="jcsb"
          pb={1}
          pt={1}
        >
          <Grid container>
            <Grid item xs={8}>
              <span
                className="summaryLabelCls"
                style={{ fontSize: "15px",  color:'#000000'  }}
              >
                Payment Mode
              </span>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={3}>
              <span
                className="summaryValueCls"
                style={{ fontSize: "15px", color:'#000000', paddingLeft:'5px' }}
              >
                :  payFast
              </span>
            </Grid>
          </Grid>
        </Typography>
      </Grid>
  );
}
